import {
  API_DEFEITOS,
  API_DEFEITOS_CATALOGO,
  API_INSPECOES,
  API_RETRABALHOS,
} from '../api/apiConfig';
import {
  DefeitoCatalogo,
  DefeitoPallet,
  InspecaoPallet,
  RetrabalhoPallet,
} from '../types/qualidade';
import { createCrudService } from './crudFactory';

export const inspecoesService = createCrudService<InspecaoPallet>(API_INSPECOES);
export const defeitosService = createCrudService<DefeitoPallet>(API_DEFEITOS);
export const retrabalhosService =
  createCrudService<RetrabalhoPallet>(API_RETRABALHOS);
export const defeitosCatalogoService =
  createCrudService<DefeitoCatalogo>(API_DEFEITOS_CATALOGO);
